import React from "react";

// components
import Paginate from "../../../components/ui/paginate";
import IBlogCard from "../misc/BlogCard";

// state and service
import { get_blogs } from "../../../service/api/blog";

import { useAppDispatch, useAppSelector } from "../../../store";
import CustomHeader from "../../../components/ui/CustomHeader/CustomHeader";
import { setOffset } from "../../../store/slices/blog";

const BlogDashboard = () => {
  const dispatch = useAppDispatch();
  const { blogs, limit, offset, total, blogsLoading, blogsError } =
    useAppSelector(({ blog }) => blog);

  const onLoad = React.useCallback(() => {
    get_blogs(dispatch, limit, offset);
  }, [dispatch, limit, offset]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);
  const publishedBlogs = blogs.filter((item) => item.is_published);
  const currentPage = limit > 0 ? Math.floor(offset / limit) + 1 : 1;
  const lastPage = limit > 0 ? Math.max(1, Math.ceil(total / limit)) : 1;

  return (
    <main className="h-full">
      <section className="py-12 md:py-24 lg:py-32 bg-primary-900">
        <div className="max-w-7xl flex items-center px-6 xl:px-0 pt-20 mx-auto text-center">
          <CustomHeader
            title="Corporate Setup Blog"
            description="Stay up to date with our latest news and updates."
            titleColor="text-white"
            descriptionColor="text-white"
          />
        </div>
      </section>

      <section className="py-12 md:py-24 lg:py-32 bg-customgreen">
        <div className="max-w-7xl mx-auto px-6 xl:px-0">
          <h3 className="text-2xl md:text-3xl lg:text-4xl text-primary-900 text-center font-bold mb-8">
            Latest From Our Blog
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogsLoading ? (
              <p className="col-span-full text-center py-12 text-primary-600">
                Loading blogs...
              </p>
            ) : blogsError ? (
              <p className="col-span-full text-center py-12 text-red-600">
                {blogsError}
              </p>
            ) : publishedBlogs.length > 0 ? (
              publishedBlogs.map((item) => (
                <IBlogCard key={item.id} item={item} />
              ))
            ) : (
              <div className="col-span-full text-center py-12">
                <p className="text-primary-600 text-lg">
                  No published blogs available at the moment.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Paginate
        current_page={currentPage}
        last_page={lastPage}
        disabled={blogsLoading}
        onNext={() => {
          if (!blogsLoading && currentPage < lastPage) {
            dispatch(setOffset(offset + limit));
          }
        }}
        onBack={() => {
          if (!blogsLoading && currentPage > 1) {
            dispatch(setOffset(offset - limit));
          }
        }}
      />
    </main>
  );
};

export default BlogDashboard;
